import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Icon, Button, Avatar, Tag } from 'antd';
import { connect } from 'react-redux';
import Layout from '../Layout';
import EditForm from '../../components/EditForm';
import InfoItem from '../../components/InfoItem';
import { getById, resetState } from '../../modules/reports';

class ReportForm extends EditForm {

  renderName = (place, name = place.name, linkStart = 'places') => {

    return (
      <Fragment>
        <Avatar
          size={64}
          src={place.logo}
          className="mr-1"
        />
        <Link to={`/${linkStart}/${place.id}`}>{name}</Link>
      </Fragment>
    );
  };

  render() {
    const { data } = this.props;

    if (data.place) {
      return (
        <Layout>
          <Button className="buttonSubmit mb-2"
                  type="primary"
                  onClick={this.goBack}
          >
            <Icon type="arrow-left" />
            Back
          </Button>
          <div className="container-sm">
            <Row>
              <Col>
                <div className="gutter-box px-2 py-1">
                  <Tag color="orange">{data.type}</Tag>
                  <InfoItem label="Place"
                            value={this.renderName(data.place)}
                            valueSpan={16}
                            labelSpan={8}
                            className="mt-1 mb-3"
                  />
                  {data.duplicate_place ?
                    <InfoItem label="Duplicate Place"
                              value={this.renderName(data.duplicate_place)}
                              valueSpan={16}
                              labelSpan={8}
                              className="mt-1 mb-3"
                    /> :
                    null
                  }
                  <InfoItem label="User"
                            value={this.renderName(data.user, data.user.full_name, 'clients')}
                            valueSpan={16}
                            labelSpan={8} />
                </div>
              </Col>
            </Row>
          </div>
        </Layout>
      );
    }
    return null;
  }
}

export default connect(
  state => ({
    ...state.reports,
  }),
  {
    getById,
    resetState,
  },
)(ReportForm);



// WEBPACK FOOTER //
// ./src/containers/Reports/ReportForm.js